class EngravingJackDanielsPromotion extends HTMLElement {
  constructor() {
    super();

    this.cart = document.querySelector("cart-drawer");
    this.targetSections = {
      sections: this.cart.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
    };

    this.engravingProps = {
      _Size: "tenpt",
      _Font: "ffranklin",
      _Language: "English",
      _Engraving_Type: "caseback",
    };

    this.addToCartDefaultText = "ADD TO CART";
    this.addToCartLoadingText = "ADDING TO CART";
  }

  // Called when the element is added to the document.
  connectedCallback() {
    this.loadSectionElements();
    this.loadSectionElementsEventListeners();
  }

  // Called when the element is removed from the document.
  disconnectedCallback() {
    this.disconnectSectionElementsEventListeners();
  }

  /**
   * Toggles the visibility of the modal associated with the promotion.
   */
  toggleModalVisibility() {
    const currentState =
      this.modal.dataset.showEngravingJackDanielsPromotionModal;

    this.modal.dataset.showEngravingJackDanielsPromotionModal =
      currentState === "false" ? true : false;
  }

  /**
   * Shows or hides the empty error message based on the flag value.
   * @param {boolean} flag - Flag to show or hide the empty error message.
   */
  showEmptyError(flag) {
    this.emptyErrorMessage.dataset.showEmptyError = flag;
  }

  /**
   * Event handler for adding items to the cart.
   * Shows an empty error message if the input value is empty.
   */
  addToCartEventHandler() {
    /* FIXME: this was hardcoded on purpose for the launch of a new product, 
    ideally there should be a setting to decide wether or not an engraving message is required */
    const isInputEmpty = this.checkInputValue();
    if (isInputEmpty) {
      //this.showEmptyError();
      // add the product without engraving by triggering a click on the normal ATC
      const mainATC = document.querySelector(".product-form__submit");
      if(mainATC) mainATC.click();
      this.toggleModalVisibility();
      return;
    }

    const id = this.addToCartBtn.dataset.variantId;
    const inputValue = this.input.value;
    const productObject = {
      id,
      quantity: 1,
      properties: {
        ...this.engravingProps,
        Line1: inputValue,
      },
    };

    const engravingObject = {
      id: EngravingJackDanielsPromotionCurrentCaseBack.variantId,
      quantity: 1,
      properties: {
        _isEngravingService: true,
        _relatedProductKey: "",
      },
    };

    this.addProductAndEngravingToTheCart(productObject, engravingObject);
  }

  /**
   * Add product and engraving to the cart
   * @param {Object} productObject Product
   * @param {Object} engravingObject Engraving product
   */
  async addProductAndEngravingToTheCart(productObject, engravingObject) {
    this.setLoadingState(true);
    let parsedResponse = {};
    let cartDataResponse = {};
    debugger;
    try {
      // Build & add product data object
      const productData = {
        ...this.targetSections,
        items: [{ ...productObject }],
      };
      const productResponse = await this.addToCart(productData);

      // Build & add engraving data object
      if (engravingObject) {
        const productKey = productResponse.items[0].key;
        engravingObject.properties._relatedProductKey = productKey;
        const engravingData = {
          ...this.targetSections,
          items: [{ ...engravingObject }],
        };
        const engravingDataResponse = await this.addToCart(engravingData);
        parsedResponse = {
          id: engravingDataResponse.items.map((item) => item.id),
          sections: engravingDataResponse.sections,
        };

        cartDataResponse = parsedResponse;
      } else {
        parsedResponse = {
          id: productResponse.items.map((item) => item.id),
          sections: productResponse.sections,
        };

        cartDataResponse = productResponse;
      }

      // Publish event
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: "jack-daniels-promo-caseback",
        productVariantId: parsedResponse.id,
        cartData: cartDataResponse,
      });

      // Render and open cart
      this.cart.renderContents(parsedResponse);
      this.cart.classList.remove("is-empty");
    } catch (error) {
      console.error(
        `Engraving Jack Daniels Promotion | addProductAndEngravingToTheCart | ${error.message}`
      );
    } finally {
      this.setLoadingState(false);
      this.toggleModalVisibility();
      this.resetInputValue();
    }
  }

  /**
   * Makes an asynchronous request to add items to the cart.
   * @param {Object} data - Data to be added to the cart.
   * @returns {Promise<Object>} The response from the cart addition request.
   */
  async addToCart(data) {
    try {
      const request = await fetch(window.Shopify.routes.root + `cart/add.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      const response = await request.json();
      return response;
    } catch (error) {
      throw new Error(
        `An error occurred during the POST request: ${error.message}`
      );
    }
  }

  /**
   * Set loading state to elements
   * @param {Boolean} flag Set loading state to selected elements
   */
  setLoadingState(flag) {
    this.addToCartBtn.innerHTML = flag
      ? this.addToCartLoadingText
      : this.addToCartDefaultText;

    this.addToCartBtn.disabled = flag;

    this.loadingSpinner.classList[flag ? "remove" : "add"]("hidden");
  }

  /**
   * Checks if the input is empty
   * @returns {Boolean} Returns true if the input is empty
   */
  checkInputValue() {
    const inputValue = this.input.value;
    return inputValue.trim() === "";
  }
  /**
   * Set empty input value
   */
  resetInputValue() {
    this.input.value = "";
  }

  /**
   * Loads necessary section elements into class properties.
   */
  loadSectionElements() {
    this.section = this;

    this.defaultEngravingBtn = document.querySelector(
      `[data-engraving-component-trigger]`
    );

    this.openEngravingModalBtn = document.querySelector(
      "#engraving-jack-daniels-promotion--open-modal"
    );

    this.closeEngravingModalBtn = this.section.querySelector(
      "#jack-daniels-promotion-modal--close-modal"
    );

    this.modal = this.section.querySelector(
      "#engraving-jack-daniels-promotion--modal"
    );

    this.input = this.section.querySelector(`input[type="text"]`);

    this.emptyErrorMessage = this.section.querySelector("#modal-empty-error");

    this.addToCartBtn = this.section.querySelector(
      "#jack-daniels-promotion-modal--add-engraving"
    );

    this.loadingSpinner = this.querySelector(".loading-overlay");
  }

  /**
   * Adds event listeners to section elements.
   */
  loadSectionElementsEventListeners() {
    this.input.addEventListener("input", () => {
      this.showEmptyError(false);
    });

    this.openEngravingModalBtn.addEventListener(
      "click",
      this.toggleModalVisibility.bind(this)
    );

    this.closeEngravingModalBtn.addEventListener(
      "click",
      this.toggleModalVisibility.bind(this)
    );

    this.addToCartBtn.addEventListener(
      "click",
      this.addToCartEventHandler.bind(this)
    );
  }

  /**
   * Removes event listeners from section elements.
   */
  disconnectSectionElementsEventListeners() {
    this.input.removeEventListener("input", () => {
      this.showEmptyError(false);
    });

    this.openEngravingModalBtn.removeEventListener(
      "click",
      this.toggleModalVisibility.bind(this)
    );

    this.closeEngravingModalBtn.removeEventListener(
      "click",
      this.toggleModalVisibility.bind(this)
    );

    this.addToCartBtn.removeEventListener(
      "click",
      this.addToCartEventHandler.bind(this)
    );
  }
}
customElements.define(
  "engraving-jack-daniels-promotion",
  EngravingJackDanielsPromotion
);
